<template>
  <div style="height: 79vh; overflow-y: scroll;" class="mb-5">
    <section class="container" v-if="is_edit">
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-right" @click="organizationUpdate">
            Save Changes
            <i class="fas fa-pencil-alt"></i>
          </button>
        </div>
        <div class="col-12 col-sm-6">
          <h5>Settings</h5>
          <div class="form-group">
            <label for="org_name">Organization Name</label>
            <input
              type="text"
              class="form-control"
              id="org_name"
              placeholder="Enter Name"
              v-model="org_details.org_name"
            />
          </div>
          <div class="form-group">
            <label for="firstName">Organization Email</label>
            <input
              type="text"
              class="form-control"
              id="org_email"
              placeholder="Enter Name"
              v-model="org_details.org_email"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <!-- <h5>Choose Logo</h5> -->
          <div class="form-group">
            <div v-if="org_details.org_logo === ''">
              <label>Choose Logo</label>
              <vue-dropzone
                ref="myVueDropzone"
                :options="dropzoneOptions"
                :awss3="awss3"
                v-on:vdropzone-s3-upload-error="s3UploadError"
                v-on:vdropzone-s3-upload-success="s3UploadSuccess"
                id="dropzone"
                v-on:vdropzone-file-added="vfileAdded"
                style="background: #1B1B1B"
              >
              </vue-dropzone>
            </div>
            <div v-else class="mb-2">
              <div class="mb-2">
                <label>Choose Logo</label>
                <button
                  class="btn btn-outline-danger btn-sm"
                  style="float:right;"
                  @click="org_details.org_logo = ''"
                >
                  Change Image
                </button>
              </div>
              <div class="text-center">
                <img
                  :src="org_details.org_logo"
                  :alt="org_details.org_name"
                  style="width: 100px; border-radius: 50%;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container" v-else>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-right" @click="is_edit=true">
            Edit Profile
            <i class="fas fa-pencil-alt"></i>
          </button>
        </div>
        <div class="col-12 col-sm-6">
          <h5>Info</h5>
          <div class="form-group">
            <label for="org_name">Organization Name</label>
            <p>{{ org_details.org_name }}</p>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="org_email">Organization Email</label>
                <div v-show="org_details.org_email != ''">
                    <p>{{ org_details.org_email }}</p>
                </div>
                <div v-show="org_details.org_email == ''">
                    <p>No Email provided</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="form-group">
                <label for="org_logo">Organization Logo</label>
                <div v-show="org_details.org_logo != ''">
                    <img :src="org_details.org_logo" :alt="org_details.org_name" style="width: 100px; border-radius: 50%;">
                </div>
                <div v-show="org_details.org_logo == ''">
                    <img src="../../assets/community-img.png" :alt="org_details.org_name" style="width: 100px; border-radius: 50%;">
                </div>
              </div>
        </div>
      </div>
    </section>
    <section class="mt-2">
      <div class="text-center">
        <h6>
          <span class="text-danger">Danger zone</span>
        </h6>
        <button
          class="btn btn-danger"
          style="margin: 5% 0;"
          data-toggle="modal"
          data-target="#deleteOrganization"
        >
          Deactivate Organization
        </button>
      </div>
    </section>
    <div class="position-center" id="loader" style="width: 5%; display: none;">
      <img src="../../assets/loader.gif" alt="" style="width: 100%" />
    </div>
    <div
      class="modal"
      id="deleteOrganization"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <i class="fas fa-question fa-4x"></i>
            <div class="mt-2 mb-2">
              <p class="modal-title"><b>Are you sure?</b></p>
              <p>You can login back to meetbeans account.</p>
            </div>
            <button
              type="submit"
              @click="deleteOrganization"
              id="yes-deactive"
              class="btn btn-primary"
            >
              Yes, delete
            </button>
            <button
              class="btn btn-secondary ml-2"
              id="no-deactive"
              data-dismiss="modal"
              aria-label="Close"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "dashboard",
  data() {
    return {
      is_edit: false,
      user: { is_admin: false, company: "NA", designation: "NA" },
      baseUrl: this.$store.state.baseUrl,
      org_details: {
        is_active: "",
        org_email: "",
        org_id: "",
        org_logo: "",
        org_name: "",
        role: "",
        total_attendees: 0,
        total_events: 0,
        total_members: 0,
        total_sessions: 0,
      },
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 10,
        maxFiles: 1,
        acceptedFiles: "image/*",
        params: {
          success_action_status: 201,
        },
        addRemoveLinks: true,
        headers: { "Access-Control-Allow-Origin": "*" },
        dictDefaultMessage:
          'UPLOAD <i class="fas fa-upload"></i> <br> <small style=\'font-size:10px;\'><i class="fas fa-info-circle text-info"></i> This will give others an idea about the organization</small>',
      },
      awss3: {
        signingURL: this.baseUrl + "/signature", //Where you will get signed url
        headers: {},
        params: {},
        sendFileToServer: true, //If you want to upload file to your server along with s3
        withCredentials: false,
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  created() {
    if (localStorage.getItem("user_info")) {
      this.user = JSON.parse(localStorage.getItem("user_info"));
    }
    this.getUser();
  },
  mounted: function(){
      this.getDetails();
  },
  methods: {
    vfileAdded(file) {
      console.log(file);
      let file_name = file.name;
      this.awss3.signingURL = this.baseUrl + "/signature/" + file_name;
      this.dropzoneOptions.url = this.baseUrl + "/signature/" + file_name;
    },
    s3UploadError(errorMessage) {
      console.log(errorMessage);
    },
    s3UploadSuccess(s3ObjectLocation) {
      this.org_details.org_logo = s3ObjectLocation;
    },
    getDetails: function() {
      this.$store
        .dispatch("getOrgDetails", this.$route.params.id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.org_details = resp.data.data;
            console.log('org: ', this.org_details)
          }
        });
    },
    getUser: function() {
      let data = {
        uid: this.user.uid,
        email: this.user.email,
      };
      this.$store.dispatch("getUserInfo", data).then((resp) => {
        if (resp.data.status === "success") {
          this.user = resp.data.data;
          //   console.log(this.user)
        }
      });
    },
    organizationUpdate: function() {
      this.$store.dispatch("updateOrganization", {id: this.$route.params.id, orgDetails: this.org_details}).then((resp) => {
        if (resp.data.status === "success") {
          this.is_edit = false;
          this.$root.$emit("getUpdatedOrgsList");
          this.$toast.open({
            message: "Profile updated",
            type: "success",
            position: "top",
            duration: 500,
            queue: true,
          });
        }
      });
    },
    deleteOrganization: function() {
      console.log('delete org', this.$route.params.id);
      this.$store.dispatch("deleteOrganization", this.$route.params.id).then((resp) => {
        if (resp.data.status === "success") {
          this.$root.$emit("getUpdatedOrgsList");
          document.getElementById("no-deactive").click();
          Swal.fire(
            "Your organization has been successfully deleted"
          );
          // this.$root.$emit("logout");
        } else {
          console.log('failed delete org', resp.data);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
h6 {
  margin: 10px 0px;
  font-size: 10px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #e43f52;
  line-height: 0;
  background: #000;
}

h6 span {
  padding: 0 20px;
  background: #000;
  font-size: 14px;
}
</style>
